/**
 * Auth environment detection utilities
 * 
 * isPreviewAuthEnvironment(): Determines auth flow (popup vs redirect)
 * - Used by signInWithGoogle to decide popup or redirect
 * - Excludes lovableproject.com (published URL → redirect flow)
 * 
 * isLovableDomain(): Broader detection for route guarding
 * - Used by ProtectedRoute for auto-preview-mode
 * - Includes lovableproject.com
 */

export function isPreviewAuthEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return (
    h.includes('lovable.app') ||
    h.includes('lovable.dev') ||
    h === 'localhost' ||
    h === '127.0.0.1'
  );
}

export function isLovableDomain(): boolean {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return (
    h.includes('lovable.app') ||
    h.includes('lovable.dev') ||
    h.includes('lovableproject.com')
  );
}
